exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-category {\n  padding: 16px; }\n  .add-category button {\n    background-color: #4caf50;\n    color: white; }\n\n.categories-list {\n  margin-left: 16px; }\n\nmat-table {\n  width: 100%; }\n\n.edit-icon {\n  color: #4caf50; }\n\n.delete-icon {\n  color: red; }\n\nmat-card {\n  padding: 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/categories-panel/categories-panel.component.scss
// module id = ../../../../../src/app/components/admin/components/categories-panel/categories-panel.component.scss
// module chunks = main